// =========================================================================================@@
// Last Updated Date: Jul 12, 2023
// Last Updated By: Steven Yuen
// Status Level: 2
// ===========================================================================================

import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import uiConstants from 'config/constants/ui'
import { useMe, useOrganization } from 'src/core/graphql/hooks'
import EyeQNav from 'src/sites/custom/eyeq/UI/Nav'
import EmailVerificationBanner from 'src/sites/kits/Global/components/EmailVerificationBanner'
import { useGlobalState } from 'src/sites/state'
import HeaderActionBlock from '~/components/MainMenu/HeaderActionBlock'
import Logo from '~/components/MainMenu/Logo'
import MainMenuMobile from '~/components/MainMenu/Mobile'
import Nav from '~/components/MainMenu/Nav'

const HeaderLayout = ({ children }) => {
   const { theme } = useGlobalState()
   const { me, isLoggedIn } = useMe()
   const { organization } = useOrganization()
   const emailVerificationBannerVisible = isLoggedIn && !me?.emailVerification.completed &&
      me?.emailVerification?.pendingRequests?.length > 0 &&
      organization?.userEmailVerificationRequired

   return (
      <>
         {emailVerificationBannerVisible && (
            <EmailVerificationBanner />
         )}
         <View
            position="sticky"
            top="0px"
            left="0px"
            right="0px"
            display="block[a-c] none[d-f]"
            zIndex={uiConstants.zIndexes.mainMenu}>
            <MainMenuMobile />
         </View>
         <View
            position="sticky"
            top="0px"
            display="none[a-c] flex[d-f]"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            height={theme.tmpHeaderHeight}
            backgroundColor="var(--headerMenuBackgroundColor)"
            borderBottom="1px solid var(--mainMenuLineColor)"
            paddingHorizontal={theme.tmpViewportPadding}
            transition="200ms background-color"
            zIndex={uiConstants.zIndexes.mainMenu}>
            {organization.slug === 'eyeq' && <EyeQNav />}
            {organization.slug !== 'eyeq' && (
               <>
                  <View display="flex" alignItems="center" flex="1 1 auto">
                     <Logo />
                     <View width="30px" height="40px" />
                     <Nav display="flex" flex="0 0 auto" orientation="horizontal" />
                  </View>
                  <View display="flex" alignItems="center" flex="0 0 auto">
                     <HeaderActionBlock />
                  </View>
               </>
            )}
         </View>
         <View
            backgroundColor="var(--bodyBackgroundColor)"
            width="100vw"
            display="block[a-c] flex[d-f]"
            zIndex="1">
            <View width="100%">
               {children}
            </View>
         </View>
      </>
   )
}

HeaderLayout.propTypes = {
   children: PropTypes.node.isRequired
}

export default HeaderLayout
